export enum StencilFailName {
  DecrementStencilOp = 'DecrementStencilOp',
  DecrementWrapStencilOp = 'DecrementWrapStencilOp',
  IncrementStencilOp = 'IncrementStencilOp',
  IncrementWrapStencilOp = 'IncrementWrapStencilOp',
  InvertStencilOp = 'InvertStencilOp',
  KeepStencilOp = 'KeepStencilOp',
  ReplaceStencilOp = 'ReplaceStencilOp',
  ZeroStencilOp = 'ZeroStencilOp'
}
